var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tlrd6vnwja"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6427",
    width: 80,
    height: 80,
    rx: 40,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Property 1=07",
    style: {
      clipPath: "url(#tlrd6vnwja)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6426",
    width: 80,
    height: 80,
    rx: 40,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 848",
    d: "M-2.281 51.732s11.958-7.1 16.038-7.548 26.418-22.067 26.418-22.067l9.188 2.158 4.213 6.075 6.74 15.226s11.984 5.583 15.84 10.23 29.506-29.966 29.2-30.653-41.745-44.175-41.745-44.175H17.87l-39.809 30.284z",
    style: {
      fill: "#ff6800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 793",
    d: "M20.991 113.329a1.219 1.219 0 0 1-.912-.495 2.071 2.071 0 0 1-.313-1.99c.747-2.9 5.353-7.377 11.009-9.4 4.962-1.773 11.313-.713 20.116.764a185.867 185.867 0 0 0 26.546 2.981.378.378 0 0 1 .365.391.39.39 0 0 1-.391.365 186.646 186.646 0 0 1-26.65-3c-8.681-1.46-14.954-2.511-19.733-.8-5.926 2.121-9.914 6.517-10.523 8.872a1.425 1.425 0 0 0 .148 1.294c.078.1.235.252.356.235.278-.017.712-.678 1.1-1.269.878-1.329 2.068-3.145 4.3-3.076a.378.378 0 0 1 .365.391.4.4 0 0 1-.391.365c-1.8-.052-2.824 1.495-3.649 2.737-.573.869-1.034 1.564-1.686 1.608a.065.065 0 0 1-.057.027z",
    transform: "translate(-9.175 -46.907)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 794",
    d: "M23.871 123.35a1.531 1.531 0 0 1-1.051-.391 1.6 1.6 0 0 1-.434-1.59c.269-1.156 2.468-4.614 5.909-7.377a.377.377 0 1 1 .469.59c-3.484 2.807-5.448 6.117-5.648 6.961a.864.864 0 0 0 .209.86.886.886 0 0 0 .9.13.379.379 0 1 1 .235.721 2 2 0 0 1-.589.096z",
    transform: "translate(-10.422 -53.158)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 795",
    d: "M27.3 125.985a1.614 1.614 0 0 1-.773-.182 1.521 1.521 0 0 1-.739-1.46c0-1.816 3.875-5.9 6.482-8.194a.382.382 0 0 1 .5.574c-3.432 3.023-6.221 6.447-6.221 7.62a.834.834 0 0 0 .348.8 1.591 1.591 0 0 0 1.451-.252.377.377 0 0 1 .408.635 2.813 2.813 0 0 1-1.456.459z",
    transform: "translate(-12.035 -54.159)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 796",
    d: "M31.629 128.634a1.085 1.085 0 0 1-.878-.452 1.835 1.835 0 0 1-.356-1.451c.391-2.668 5.431-6.283 6-6.682a.381.381 0 1 1 .434.626c-1.842 1.294-5.413 4.258-5.691 6.169a1.09 1.09 0 0 0 .2.869.332.332 0 0 0 .278.165c.582 0 1.581-1.243 2.111-1.911a9.961 9.961 0 0 1 .652-.765c1.929-1.79 4.614-2.007 7.012-2.016a.382.382 0 0 1 0 .765.854.854 0 0 1-.148 0c-2.3 0-4.649.235-6.343 1.807-.13.122-.348.391-.582.678-.769.981-1.742 2.198-2.689 2.198z",
    transform: "translate(-14.173 -55.99)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 797",
    d: "M60.684 101.158c-.417-.261-.8.4-.382.652a9.575 9.575 0 0 1 3.163 13.251.378.378 0 0 0 .652.382 10.347 10.347 0 0 0-3.433-14.285z",
    transform: "translate(-28.057 -47.179)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 798",
    d: "M68.6 103.051a1.289 1.289 0 0 1-.191.026 5.843 5.843 0 0 0-.782.1 9.992 9.992 0 0 1 1.416 13.4c-.287.4.374.782.652.382a10.719 10.719 0 0 0-1.095-13.908z",
    transform: "translate(-31.56 -48.09)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 799",
    d: "M107.227 128.194a31.959 31.959 0 0 1-13.642-3.146.379.379 0 0 1 .322-.686c10.288 4.858 20.42 3.346 25.894-.3 3.215-2.137 4.918-5.039 4.779-8.167a9.409 9.409 0 0 0-1.929-4.9.38.38 0 1 1 .617-.443 10 10 0 0 1 2.068 5.309c.148 3.406-1.669 6.543-5.109 8.837a23.832 23.832 0 0 1-13 3.496z",
    transform: "translate(-43.571 -51.519)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 800",
    d: "M121.311 91.6c-7.377-6.343-18.969-11.3-23.322-12.469.009.261 0 .521-.009.782 4.432 1.234 15.658 6.091 22.844 12.269a.373.373 0 0 0 .243.1.384.384 0 0 0 .287-.13.4.4 0 0 0-.043-.552z",
    transform: "translate(-45.724 -36.929)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 801",
    d: "m86.792 102.986-2.937 1.269 6.5.982a16.137 16.137 0 0 1-3.563-2.251z",
    transform: "translate(-39.133 -48.06)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 802",
    d: "M38.565 128.48c-.73 0-1.486-.66-2.659-1.686a39.96 39.96 0 0 0-4.571-3.554c-4.345-2.859-14.094-3.841-26.745-2.7-7.8.7-21.845.843-28.266-6.2-2.928-3.206-3.91-7.551-2.928-12.912 2.468-13.477 30.812-22.036 32.02-22.392a.377.377 0 1 1 .217.721c-10.053 2.98-29.578 11.383-31.49 21.8-.938 5.118-.009 9.245 2.746 12.261 6.2 6.786 19.977 6.638 27.632 5.952 12.817-1.156 22.748-.13 27.232 2.824a38.523 38.523 0 0 1 4.657 3.623c1.043.913 1.79 1.573 2.242 1.494.139-.026.252-.226.3-.513.148-1.06-.7-3.641-4.988-5.822a.381.381 0 0 1 .348-.678c4.657 2.381 5.579 5.275 5.387 6.613a1.213 1.213 0 0 1-.9 1.147 1.762 1.762 0 0 1-.234.022z",
    transform: "translate(12.587 -36.877)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 803",
    d: "M100.686 160.712c-.852 0-1.694-.947-1.972-2.215a5.927 5.927 0 0 0-2.2-3.059c-.174-.122-1.173-1.147-1.051-1.321s1.312.582 1.486.7a6.587 6.587 0 0 1 2.5 3.519c.226 1.069.869 1.616 1.243 1.616.243-.009.435-.33.5-.86a8.134 8.134 0 0 0-4.9-7.525.391.391 0 0 1-.235-.356.377.377 0 0 1 .243-.347 5.184 5.184 0 0 1 6.117 2.511 18.869 18.869 0 0 0 2.468 3.476.382.382 0 0 1 .226.339.393.393 0 0 1-.374.391c-.191 0-.556.017-2.971-3.806a4.536 4.536 0 0 0-4.171-2.4c3.259 1.929 4.631 5.622 4.344 7.812-.173 1.329-.912 1.5-1.225 1.511a.043.043 0 0 1-.028.014z",
    transform: "translate(-44.545 -70.291)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 804",
    d: "M84.176 142.44a.38.38 0 0 1-.348-.226c-2.007-4.423-6.239-8.116-12.591-10.983a47.965 47.965 0 0 0-20.507-4.5.37.37 0 0 1-.391-.373.386.386 0 0 1 .374-.391 48.552 48.552 0 0 1 20.837 4.57c6.517 2.946 10.879 6.769 12.964 11.357a.382.382 0 0 1-.191.5.229.229 0 0 1-.147.046z",
    transform: "translate(-23.492 -58.779)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 805",
    d: "M70.182 130.035c-.156-.069-.313-.139-.469-.2a9.1 9.1 0 0 0-6.639 14.111c.217.061.443.1.66.148a.341.341 0 0 0 .043-.452 8.348 8.348 0 0 1 6.074-13.069.394.394 0 0 0 .331-.538z",
    transform: "translate(-28.718 -60.59)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 806",
    d: "M64.079 128.532a9.62 9.62 0 0 0-6.5 14.389c.252.417.912.035.652-.382-3.337-5.483.321-12.973 6.752-13.347a.374.374 0 0 0 .356-.3c-.426-.116-.839-.221-1.26-.36z",
    transform: "translate(-26.23 -59.982)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 807",
    d: "M4.8 122.975a.371.371 0 0 1-.365-.286.378.378 0 0 1 .278-.461c2.277-.565 8.324-.035 8.576-.009a.379.379 0 1 1-.061.756c-.061-.009-6.178-.547-8.324-.009-.044.001-.079.009-.104.009z",
    transform: "translate(-2.064 -56.919)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 808",
    d: "M57.1 57.045c3.311-.469 5.657-10.67 5.657-10.67 1.938 1.79 13.225 3.18 14.806 2.363 0-4.518-3.5-8.037-11.2-8.037-9.106 0-12.148 3.8-12.148 9.871v6.074l.078.13c1.325-.157 1.472.278 2.807.269z",
    transform: "translate(-25.302 -18.994)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 809",
    d: "M85.893 76.887a.382.382 0 0 1 0-.765 2.079 2.079 0 0 0 1.564-.513.747.747 0 0 0 .156-.669c-.1-.6-1.434-.938-2.068-1.008a.377.377 0 0 1-.339-.374v-3.475a.382.382 0 0 1 .765 0v3.145c.7.122 2.216.513 2.389 1.581a1.564 1.564 0 0 1-.33 1.286 2.678 2.678 0 0 1-2.137.792z",
    transform: "translate(-39.763 -32.527)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 810",
    d: "M91.512 68.41v.756a.761.761 0 0 0 1.521 0v-.756a.761.761 0 0 0-1.521 0z",
    transform: "translate(-42.705 -31.584)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 811",
    d: "M72.465 68.41v.756a.761.761 0 0 0 1.521 0v-.756a.761.761 0 0 0-1.521 0z",
    transform: "translate(-33.817 -31.584)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 812",
    d: "M72.2 62.344a9.094 9.094 0 0 0-1.773.547c-.452.191-.061.852.382.652a9.27 9.27 0 0 1 1.59-.469c.491-.104.283-.834-.199-.73z",
    transform: "translate(-32.774 -29.089)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 813",
    d: "M92.839 61.609c-.426-.182-.895-.287-1.3-.5-.426-.226-.86.408-.426.626.478.243.991.382 1.477.591.449.187.701-.526.249-.717z",
    transform: "translate(-42.434 -28.493)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 814",
    d: "M75.742 85.461c-.565-.087-1.321-.348-1.364-1.025-.026-.487-.791-.487-.756 0a2.036 2.036 0 0 0 1.92 1.755c.478.07.687-.66.2-.73z",
    transform: "translate(-34.356 -39.233)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 815",
    d: "M68 74.87a.386.386 0 0 1-.382-.348.38.38 0 0 1 .348-.409 13.587 13.587 0 0 0 5.474-1.407c3.676-2.12 3.545-8.846 3.328-19.985-.026-1.182-.043-2.407-.07-3.684-.087-5.57-3.58-8.281-10.662-8.281-8.142 0-11.774 2.928-11.774 9.5v6.074a.382.382 0 1 1-.765 0v-6.077C53.5 43.258 57.48 40 66.03 40c7.481 0 11.331 3.041 11.426 9.028.017 1.277.043 2.5.07 3.684.226 11.418.356 18.317-3.7 20.663a14.121 14.121 0 0 1-5.787 1.512c-.019-.017-.028-.017-.039-.017z",
    transform: "translate(-24.967 -18.667)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 816",
    d: "M54.433 69.91c-2.494-.122-4.249.278-5.214 1.2a2.581 2.581 0 0 0-.817 1.912 2.816 2.816 0 0 0 .886 2.051 4.408 4.408 0 0 0 3.2 1.06h.035c.278 1 .991 4.536-2.242 6 .3.139.617.252.938.365 3.528-2.146 1.964-6.821 1.946-6.864a.353.353 0 0 0-.374-.252 4.022 4.022 0 0 1-2.972-.843 2.081 2.081 0 0 1-.652-1.5 1.839 1.839 0 0 1 .582-1.364c.8-.765 2.407-1.1 4.657-.991a.39.39 0 0 0 .4-.356.408.408 0 0 0-.373-.418z",
    transform: "translate(-22.588 -32.615)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 817",
    d: "M40.032 46.2a7.957 7.957 0 0 0-8.463 6.934c-4.718-1.425-9.419.721-12.712 4.18-2.32 2.442-4.492 6.682-1.538 9.315a.4.4 0 0 0 .434.565c5.413-1.147 12.165-2.172 15.667 3.241 1.773 2.746 4.214.148 4.553-2.311a4.457 4.457 0 0 0 .035-.582.391.391 0 0 0 .1-.226 2.625 2.625 0 0 0-.521-2.251 1.415 1.415 0 0 0-1.112-.391 12.282 12.282 0 0 0-.7-.417 2.051 2.051 0 0 1-.313-.078 2.51 2.51 0 0 1-1.668-1.634 2.423 2.423 0 0 1 2.581-3.05 4.711 4.711 0 0 0 .573-.443c3.18-3.137 3.1-7.951 2.867-12.1h.226c.478.026.478-.73-.009-.752z",
    transform: "translate(-7.414 -21.552)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 818",
    d: "M105.516 69.181a.343.343 0 0 0 .087-.069.347.347 0 0 0 .2-.156c1.521-2.529 2.32-5.778.834-8.515a5.841 5.841 0 0 0-5.761-3.093c-.026-2.833-.547-6.378-4.266-7.768-.009-.043.287.7 0 .852.061.043.13.087.2.139a59.565 59.565 0 0 1 .382 15.129c-.043.461 5.318 1.512 7.577 3.215.26.075.504.171.747.266z",
    transform: "translate(-45.084 -23.136)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 819",
    d: "M55.325 97.308c.3.009.582.009.878.017a.368.368 0 0 0-.174-.452c-1.729-.982-1.764-4.353-1.764-4.388a.382.382 0 0 0-.765 0c0 .148.035 3.45 1.825 4.823z",
    transform: "translate(-24.967 -42.981)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 820",
    d: "m63.92 99.565-.756 1.321 3.875.443a100.964 100.964 0 0 1-3.119-1.764z",
    transform: "translate(-29.477 -46.463)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 821",
    d: "M66.705 101.364h-.043l-3.875-.443a.39.39 0 0 1-.3-.209.37.37 0 0 1 .009-.356l.756-1.321a.408.408 0 0 1 .235-.182.371.371 0 0 1 .287.043c1.008.6 2.042 1.173 3.1 1.755a.393.393 0 0 1 .182.452.381.381 0 0 1-.351.261zm-3.267-1.13 1.4.157c-.374-.209-.747-.426-1.121-.643z",
    transform: "translate(-29.143 -46.126)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 822",
    d: "M70.322 71.159a3.514 3.514 0 0 1-1.573-.374 3.911 3.911 0 0 1-2.085-3.676.378.378 0 0 1 .374-.382.4.4 0 0 1 .382.374 3.193 3.193 0 0 0 1.668 3 2.6 2.6 0 0 0 2.685-.174 3.115 3.115 0 0 0 .895-3.224.38.38 0 0 1 .747-.139c.426 2.363-.565 3.5-1.19 3.971a3.071 3.071 0 0 1-1.903.624z",
    transform: "translate(-31.11 -30.918)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 823",
    d: "M90.83 70.489a3.071 3.071 0 0 1-1.373-.33 3.975 3.975 0 0 1-1.938-3.754.382.382 0 1 1 .765 0 3.238 3.238 0 0 0 1.516 3.076 2.232 2.232 0 0 0 2.32-.174 3.1 3.1 0 0 0 .965-3.119.379.379 0 1 1 .747-.122 3.785 3.785 0 0 1-1.269 3.849 2.9 2.9 0 0 1-1.733.574z",
    transform: "translate(-40.842 -30.682)",
    style: {
      fill: "#000200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 824",
    d: "M78.488 69.151a.381.381 0 0 1-.182-.712c.113-.061 2.867-1.538 5.37-.348a.379.379 0 1 1-.321.686c-2.155-1.025-4.649.322-4.675.33a.509.509 0 0 1-.192.044z",
    transform: "translate(-36.451 -31.56)",
    style: {
      fill: "#000200"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.42d83d19.svg";
export { ForwardRef as ReactComponent };